module.exports = __webpack_public_path__ + "static/wsu-flow-map.18bffcf6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/projects/wsu-library/wsu-flow-map.jpg
// module id = 480
// module chunks = 262546004982204